import { getFluxBotToken } from "@/shared";
import { useSettingsStore } from "@/pinia";
import fetchWithAuth from "@/plugins/fetch";

export async function fetchFluxBotAction(
	wallet: string,
	action: string,
	payload?: any
): Promise<any> {
	const webSettings = useSettingsStore().settings;

	try {
	const res = await fetchWithAuth("https://gateway.fogo.fluxbeam.xyz/bot/actions", {
			method: "POST",
			body: JSON.stringify({
				wallet: wallet,
				action: action,
				payload: payload,
				settings: {
					slippage: webSettings.slippage,
					platforms: 503,
					mevProtect: webSettings.validatorTip !== null || webSettings.validatorTip != 0,
					validatorTip: 					webSettings.validatorTip === null
						? webSettings.validatorLevel
						: `${webSettings.validatorTip}`,
					priorityFee:
						webSettings.priorityFeeMax === null
							? webSettings.priorityLevel
							: `${webSettings.priorityFeeMax}`,
				},
			}),
			headers: {
				"Content-Type": "application/json",
				Authorization: getFluxBotToken(wallet),
			},
		});

		if (!res.ok) {
			const errorData = await res.json();
			console.error("FluxBot API error:", errorData);
			throw new Error(errorData?.error || res.statusText || "API request failed");
		}

		const responseData = await res.json();

		// Validate the response data
		if (!responseData) {
			throw new Error("Empty response from FluxBot API");
		}

		return responseData;
	} catch (error) {
		console.error("FluxBot action failed:", error);
		throw error instanceof Error ? error : new Error(String(error));
	}
}
